module.exports = __webpack_public_path__ + "static/media/back5.7d373d81.jpg";